import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/seo-data";

interface FeatureGridProps {
  id?: string;
}

export default function FeatureGrid({ id }: FeatureGridProps) {
  const { t } = useTranslation("home");

  const gridCategories = [
    {
      name: "Shoes",
      url: categories[0].url,
      image:
        "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20sneakers%20displayed%20on%20warm%20cream%20textured%20surface%2C%20soft%20natural%20daylight%2C%20clean%20product%20photography%2C%20simple%20composition%2C%20editorial%20style%2C%20high%20detail%2C%20modern%20lifestyle%20aesthetic%2C%20neutral%20warm%20tones&width=600&height=800&seq=feat-grid-shoes-v2&orientation=portrait",
      span: "row-span-2",
    },
    {
      name: "Hoodies/Sweaters",
      url: categories[1].url,
      image:
        "https://readdy.ai/api/search-image?query=Cozy%20minimalist%20hoodie%20sweater%20flat%20lay%20on%20warm%20beige%20textured%20background%2C%20soft%20folded%20fabric%2C%20natural%20daylight%2C%20clean%20product%20photography%2C%20modern%20editorial%20style%2C%20relaxed%20neutral%20aesthetic%2C%20high%20quality%20textile%20texture&width=600&height=380&seq=feat-grid-hoodie-v2&orientation=landscape",
      span: "",
    },
    {
      name: "T-Shirts",
      url: categories[2].url,
      image:
        "https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20neatly%20folded%20on%20light%20cream%20linen%20surface%2C%20minimalist%20presentation%2C%20soft%20natural%20daylight%20from%20side%2C%20clean%20product%20photography%2C%20warm%20neutral%20tones%2C%20simple%20elegant%20composition%2C%20editorial%20quality&width=600&height=380&seq=feat-grid-tshirt-v2&orientation=landscape",
      span: "",
    },
  ];

  return (
    <section id={id} className="bg-background-100 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            {t("categoriesTitle1")}{" "}
            <span className="text-primary-500">{t("categoriesTitle2")}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a
            href={gridCategories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="relative rounded-2xl overflow-hidden h-[400px] md:h-[520px] group cursor-pointer"
          >
            <img
              src={gridCategories[0].image}
              alt={gridCategories[0].name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-6">
              <span className="inline-block bg-black/60 backdrop-blur-sm text-white text-sm font-medium px-4 py-2 rounded-full">
                {gridCategories[0].name}
              </span>
            </div>
          </a>

          <div className="flex flex-col gap-4">
            {gridCategories.slice(1).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="relative rounded-2xl overflow-hidden h-[190px] md:h-[252px] group cursor-pointer"
              >
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 p-5">
                  <span className="inline-block bg-black/60 backdrop-blur-sm text-white text-sm font-medium px-4 py-2 rounded-full">
                    {cat.name}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}